/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { ImageList } from "@mui/material";
import { GalleryContext } from "cms/documents/document-selector/gallery/gallery-context";
import { SelectGalleryItem } from "cms/documents/document-selector/gallery/select-gallery-item";
import { isArrayNotEmpty } from "utils/empty-exists";

const DocumentListGallery = () => {

    const {
        documents,
        selectedDocument,
    } = useContext(GalleryContext);

    return (
        <>
            <ImageList
                cols={8}
                rowHeight={160}
                className="document-gallery-frame"
            >
                {isArrayNotEmpty(documents) && documents.map((document, index) => {
                    const isSelected = document?.guid === selectedDocument?.guid;
                    return (
                        <SelectGalleryItem
                            document={document}
                            isSelected={isSelected}
                            key={index}
                        />
                    );
                })}
                {!documents &&
                    <div> No documents found.</div>
                }
            </ImageList>
        </>
    );
};
export { DocumentListGallery };
